import { createContext } from "react";
import { IMQTTBrokerContext } from "./MQTTBrokerContextInterfaces";

export const initialState: IMQTTBrokerContext = {
    publishEventReport: () => new Promise((res) => res()),
    publishClusterReordering: () => new Promise((res) => res()),
    currentSetting: undefined,
    openMQTTSettingDialog: false,
    handleOpenMQTTSettingDialog: (value: boolean) => {},
    handleSecretLogoTap: () => {},
    isLocalServerActive: false,
    isBrokerConnected: false,
};

export const MQTTBrokerContext = createContext(initialState);
